module.exports = __webpack_public_path__ + "fa3c276546d0b6258c48d2c4c542d3b5.jpg";